import { TooltipHost, IconButton, DirectionalHint, getId } from '@fluentui/react';
import * as React from 'react';

export interface ICallOutProps {
  iconName: string;
}

interface IconCalloutProps {
  content: string | JSX.Element | JSX.Element[] | undefined;
  iconName?: string;
}

function extractText(node: string | JSX.Element | JSX.Element[] | undefined): string {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(extractText).join(' ');
  }
  if (React.isValidElement(node)) {
    return extractText((node as React.ReactElement).props.children);
  }
  return '';
}

export const IconCallout: React.FC<IconCalloutProps> = ({ iconName, content }) => {
  const tooltipId = React.useMemo(() => getId('iconcallout-tooltip'), []);
  const calloutProps = {
    gapSpace: 0,
    directionalHint: DirectionalHint.topCenter,
  };
  const iconProps = { iconName: iconName };
  const ariaLabel = extractText(content);

  return (
    <TooltipHost
      content={content}
      id={tooltipId}
      calloutProps={calloutProps}
    >
      <IconButton
        iconProps={iconProps}
        aria-label={ariaLabel}
      />
    </TooltipHost>
  );
};
